import styles from './OfferInProgressPage.module.scss';
import { hourglassNotDone } from '@/assets/images/emojis';
import { CallSupportButton } from '@/features/support';
import { useOfferRequest } from '../../hooks';
import { useEffect } from 'react';
import { routes } from '@/routes';
import { useNavigate } from 'react-router-dom';

export function OfferInProgressPage() {
  const navigate = useNavigate();
  const { offer, requestOffer } = useOfferRequest();

  useEffect(() => {
    requestOffer();

    const intervalId = setInterval(() => {
      requestOffer();
    }, 15000);

    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    if (offer?.status === 'NoOfferAvailable') {
      navigate(routes.offer.notAvailable);
      return;
    }

    if (offer?.status === 'Complete') {
      navigate(routes.application.base);
    }
  }, [offer]);

  return (
    <div className={styles.root}>
      <div className={styles.container}>
        <div className={styles.hourglassContainer}>
          <img
            alt="Hourglass not done"
            className={styles.hourglassImage}
            src={hourglassNotDone}
          />
        </div>
        <p className={styles.mainTitle}>Analiză dosar în procesare</p>
        <p className={styles.description}>
          OceanCredit analizează informațiile oferite și te va contacta în caz
          că e nevoie de mai multe detalii. <br aria-hidden="true" />
          <br aria-hidden="true" />
          În medie, clienții noștri primesc un răspuns în maxim 3 ore.
        </p>
      </div>
      <div className={styles.buttonsContainer}>
        <CallSupportButton />
      </div>
    </div>
  );
}
